export function isObject(a: unknown): a is AnyObject {
	return typeof a === 'object' && a !== null && !Array.isArray(a);
}

export function clone<T extends Record<string, unknown>>(obj: T): T {
	return Object.fromEntries(
		Object.entries(obj).map(([key, value]) => [key, _cloneValue(value)])
	) as T;
}

function _cloneValue<V>(value: V): V {
	if (isObject(value)) {
		return clone(value);
	}

	if (Array.isArray(value)) {
		return value.map((v) => _cloneValue(v)) as V;
	}

	return value;
}

export function compare(obj1: unknown, obj2: unknown): boolean {
	if (obj1 === obj2) {
		return true;
	}

	if (Array.isArray(obj1)) {
		return Array.isArray(obj2)
			&& obj1.length === obj2.length
			&& obj1.every((v, i) => compare(v, obj2[i]));
	}

	if (!isObject(obj1) || !isObject(obj2)) {
		return false;
	}

	const keys1 = Object.keys(obj1),
		keys2 = Object.keys(obj2);

	if (keys1.length !== keys2.length) {
		return false;
	}

	for (const key of keys1) {
		if (!Object.prototype.hasOwnProperty.call(obj2, key)) {
			return false;
		}

		if (!compare(obj1[key], obj2[key])) {
			return false;
		}
	}

	return true;
}
